import { render, staticRenderFns } from "./OwnersStaffContac.vue?vue&type=template&id=3c63ec8f&scoped=true&"
import script from "./OwnersStaffContac.vue?vue&type=script&lang=js&"
export * from "./OwnersStaffContac.vue?vue&type=script&lang=js&"
import style0 from "./OwnersStaffContac.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OwnersStaffContac.vue?vue&type=style&index=1&id=3c63ec8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c63ec8f",
  null
  
)

export default component.exports